<template>
  <div class="grid w-full grid-cols-1 gap-8 lg:grid-cols-2">
    <div
      v-for="(tool, index) in tools"
      :key="index"
      class="flex h-full w-full flex-col overflow-hidden rounded-2xl border border-[#eaecf0] bg-[linear-gradient(180deg,_#FCFCFD_0%,_#F9FAFB_100%)] lg:min-h-[400px]"
    >
      <div class="flex flex-col gap-1 p-6">
        <h1 class="text-2xl font-medium text-[#101828]">
          {{ tool.name }}
        </h1>
        <p class="text-base text-[#344054]">
          {{ tool.description }}
        </p>
      </div>
      <img
        :src="tool.image"
        alt="tool-img"
        class="h-40 w-full flex-1 object-cover sm:h-[244px]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from "vue";
import Map from "@/../images/tabbed-bento-images/powerful-add-ons/map.png";
import QrCode from "@/../images/tabbed-bento-images/powerful-add-ons/qr-code.png";

const tools = shallowRef([
  {
    name: "Map",
    description:
      "Create custom maps with variable addresses for each recipient. This feature highlights specific locations, like sold homes or landscaped properties.",
    image: Map,
  },
  {
    name: "QR Code",
    description: "Stop wasting countless hours searching for the perfect image. Our  image library allows you to quickly find anything you need.",
    image: QrCode,
  },
]);
</script>
